import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { initializeAuthThunk } from "@/store/slices/authSlice";


type Props = {
  children: React.ReactNode;
};

export default function AppInitializer({ children }: Props) {
  const dispatch = useAppDispatch();
  const { isInitialized } = useAppSelector((state) => state.auth);

  useEffect(() => {
    dispatch(initializeAuthThunk());
  }, [dispatch]);

  if (!isInitialized) {
    return <div>로딩중...</div>;
  }

  return <>{children}</>;
}